/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S1_HeadingInputs */

const tr_onbilgi_s1_heading = /** @type {(inputs: Onbilgi_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Sağlayıcı Bilgileri`)
};

const en_onbilgi_s1_heading = /** @type {(inputs: Onbilgi_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Provider Information`)
};

const de_onbilgi_s1_heading = /** @type {(inputs: Onbilgi_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Angaben zum Anbieter`)
};

const ru_onbilgi_s1_heading = /** @type {(inputs: Onbilgi_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Сведения о поставщике`)
};

/**
* | output |
* | --- |
* | "1. Provider Information" |
*
* @param {Onbilgi_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s1_heading = /** @type {((inputs?: Onbilgi_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s1_heading(inputs)
	if (locale === "de") return de_onbilgi_s1_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s1_heading(inputs)
	return tr_onbilgi_s1_heading(inputs)
});